module.exports = __webpack_public_path__ + "static/media/rest3-small.3862ab82.webp";